import * as yup from "yup";

import { Shape } from "@/core/yup";
import { AddressMaxLength } from "@/validations/address";

import { CompanyFormType } from "../../formType";

export const formSchemaAddress = yup.object<{}, Shape<MyBrokerApi.Address>>({
    street: yup.string().max(AddressMaxLength.Street).required(),
    houseNumber: yup.string().max(AddressMaxLength.HouseNumber).required(),
    zipCode: yup.string().max(AddressMaxLength.ZipCode).required(),
    city: yup.string().max(AddressMaxLength.City).required(),
    country: yup.object<{}, Shape<MyBrokerApi.TranslatedContent>>({
        id: yup.string().required(),
    }),
    type: yup.object<{}, Shape<MyBrokerApi.TranslatedContent>>({
        id: yup.string().required(),
    }),
});

export const formSchemaAddresses = yup.object<{}, Shape<CompanyFormType>>({
    addresses: yup.array(formSchemaAddress),
});
